import { createSlice } from "@reduxjs/toolkit";
import { get_req, post_req } from "../Utilities/apiUtil";
import { post_credit_guard_screen_url } from "../Utilities/apiUrl";
import { loaderActions } from "./loaderSlice";
import appConst from "../Utilities/appConst.json";
import { basketActions } from "../store/basket";

export const postCreditGuardScreen = (
  basket,
  invoice_matrix,
  history,
  location
) => {
  return async (dispatch) => {
    try {
      const data = await post_req(
        `${post_credit_guard_screen_url}&invoice_matrix=${invoice_matrix}`,
        basket
      );

      if (data && data.payload && data.isValid) {
        dispatch(basketActions.setIFrameURL(data.payload.url));
      } else {
        history.push({
          pathname: appConst.EIGHTH_PAGE,
          search: location.search,
        });
        dispatch(
          creditGuardActions.setError({
            isError: true,
            errorCode: appConst.CREDIT_GARD_FENERIC_ERROR,
          })
        );
        dispatch(loaderActions.loaderHide());
      }
    } catch (error) {
      // do not set error to true, because should go back to summary page
    }
  };
};

const creditGuardSlice = createSlice({
  name: "creditGuard",
  initialState: {
    isError: false,
    errorCode: -1,
    showIframe: false,
  },
  reducers: {
    setError: (state, action) => {
      state.isError = action.payload.isError || state.isError;
      state.errorCode = action.payload.errorCode || state.errorCode;
    },
    setShowIframe: (state, action) => {
      state.showIframe = action.payload;
    },
  },
});

export const creditGuardActions = creditGuardSlice.actions;
export default creditGuardSlice;
